import styled from 'styled-components'

import { ButtonPlain, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const ButtonClose = styled(ButtonPlain)`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${({ theme }) => theme.color.text};
	background-color: transparent;
	min-width: initial;
	width: 32px;
	height: 28px;
	padding: 0;
	margin: 0 4px;
	border-radius: 4px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	isolation: isolate;

	&:focus-visible {
		outline: 2px solid ${helpers.color.primary};
		outline-offset: -2px;
	}

	${muiRipple()}

	&:before {
		border-radius: 4px;
	}
`
